var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-feedback"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.333 1.83337H2.66634C1.93301 1.83337 1.33967 2.43337 1.33967 3.16671L1.33301 15.1667L3.99967 12.5H13.333C14.0663 12.5 14.6663 11.9 14.6663 11.1667V3.16671C14.6663 2.43337 14.0663 1.83337 13.333 1.83337ZM13.333 11.1667H3.44634L3.05301 11.56L2.66634 11.9467V3.16671H13.333V11.1667ZM7.33301 8.50004H8.66634V9.83337H7.33301V8.50004ZM7.33301 4.50004H8.66634V7.16671H7.33301V4.50004Z",
    fill: "#282828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.796404ee90f64265bec7ceadd25a4b9b.svg";
export { ForwardRef as ReactComponent };